module.exports = __webpack_public_path__ + "static/media/pin-the-look.1f0def51.jpg";